import {
  CLEAR_LEAVE_LIST_STATE,
  SET_CURRENT_LEAVE_LIST,
  SET_LEAVE_LIST_FILTER,
  SET_LOCATIONS_FOR_LEAVE_LIST,
  SET_LEAVE_LIST_STATUSES,
  SET_PROJECTS_FOR_LEAVE_LIST,
  SET_STATUSES_FOR_LEAVE_LIST,
  SET_TRUCK_OR_TRAILERS,
  SET_LOAD_MORE_FLAG,
  SET_BILL_OF_LADING_CREATION_FORM
} from '../constants/reduceConstants';
import api from '../api';
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from '../helpers/AppHelpers';
import {
  SUCCESS_CREATE_LEAVELIST,
  SUCCESS_DELETE_LEAVELIST,
  SUCCESS_UPDATE_LEAVELIST
} from '../constants/infoSnackbarData';
import { browserHistory } from '../browserHistory';
import {
  BILL_OF_LADING_EDIT_PATH,
  LEAVELIST_DETAILED_PATH,
  LEAVELIST_SUMMARY_PATH
} from '../constants/routeConstants';

export const getLeavelists = (query) => (dispatch) =>
  api.leavelist
    .getLeavelistsApi(query)
    .then((res) => {
      dispatch({ type: SET_LOAD_MORE_FLAG, payload: false });
      return res;
    })
    .catch((err) => console.log(err));

export const getFilterCriteria = () => () =>
  api.leavelist
    .getFilterCriteriaApi()
    .then((res) => res)
    .catch((err) => console.log(err));

export const getLocations = (query) => (dispatch) => {
  api.leavelist
    .getLocationsApi(query)
    .then((res) => dispatch({ type: SET_LOCATIONS_FOR_LEAVE_LIST, payload: res }))
    .catch((err) => console.log(err));
};

export const getStatuses = (query) => (dispatch) => {
  api.leavelist
    .getStatusesApi(query)
    .then((res) => dispatch({ type: SET_STATUSES_FOR_LEAVE_LIST, payload: res }))
    .catch((err) => console.log(err));
};

export const getProjects = (query) => (dispatch) => {
  api.leavelist
    .getProjectsApi(query)
    .then((res) => dispatch({ type: SET_PROJECTS_FOR_LEAVE_LIST, payload: res }))
    .catch((err) => console.log(err));
};

export const getSingleLeaveList = (id) => (dispatch) => {
  api.leavelist
    .getSingleLeaveListApi(id)
    .then((res) => dispatch({ type: SET_CURRENT_LEAVE_LIST, payload: res }))
    .catch((err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      browserHistory.push(LEAVELIST_SUMMARY_PATH);
    });
};

export const checkBillOfLadingItems = (data) => (dispatch) => {
  return api.leavelist.checkBillOfLadingItemsApi(data).then(
    (res) => {
      if (res.status === 200) {
        dispatch({ type: SET_BILL_OF_LADING_CREATION_FORM, payload: res.data });
        browserHistory.push(BILL_OF_LADING_EDIT_PATH);
      }
      return res;
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );
};

export const createLeaveList = (data) => () => {
  return api.leavelist.createLeaveListApi(data).then(
    (res) => {
      enqueueSuccessSnackbar(SUCCESS_CREATE_LEAVELIST);
      browserHistory.push(`${LEAVELIST_DETAILED_PATH}/${res.id}`);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      return errors;
    }
  );
};

export const updateLeaveList = (data, isDetailsScreen, shouldShowPopup) => (dispatch) => {
  return api.leavelist.updateLeaveListApi(data).then(
    (res) => {
      shouldShowPopup && enqueueSuccessSnackbar(SUCCESS_UPDATE_LEAVELIST);
      !isDetailsScreen && browserHistory.push(`${LEAVELIST_DETAILED_PATH}/${res.id}`);
      dispatch({ type: SET_CURRENT_LEAVE_LIST, payload: res });
      return res;
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );
};

export const checkLeaveList = (data) => () => {
  return api.leavelist.checkLeaveListApi(data).then(
    (res) => res,
    (err) => {
      const errors = JSON.parse(err.request.response);
      return errors;
    }
  );
};

export const getAssets = (query) => () =>
  api.leavelist
    .getAssetsApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const deleteLeaveList = (id) => () => {
  return api.leavelist.deleteLeaveListApi(id).then(
    () => {
      enqueueSuccessSnackbar(SUCCESS_DELETE_LEAVELIST);
      browserHistory.push(LEAVELIST_SUMMARY_PATH);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
    }
  );
};

export const getLeaveListAssetStatuses = (query) => (dispatch) => {
  api.leavelist
    .getAssetStatusesListApi(query)
    .then((res) => dispatch({ type: SET_LEAVE_LIST_STATUSES, payload: res }))
    .catch((err) => console.log(err));
};

export const searchTruckOrTrailer = (query) => (dispatch) => {
  api.asset
    .searchAssetByStringApi(query)
    .then((res) => dispatch({ type: SET_TRUCK_OR_TRAILERS, payload: res.data }))
    .catch((err) => console.log(err));
};

export const clearLeaveListState = () => (dispatch) => {
  dispatch({ type: CLEAR_LEAVE_LIST_STATE });
  dispatch({ type: SET_LOAD_MORE_FLAG, payload: false });
};

export const setLeaveListFilter = (payload) => (dispatch) => {
  dispatch({ type: SET_LEAVE_LIST_FILTER, payload });
};

export const getCsvResource = (q) => () =>
  api.leavelist
    .getCsvResourceApi(q)
    .then((res) => res)
    .catch((err) => console.log(err));
